module.exports = __webpack_public_path__ + "img/Step3.89959b0.svg";